import React from 'react';
import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  Icon,
  InputGroup,
  InputLeftElement,
  Input as ChakraInput,
  InputProps as ChakraInputProps,
} from '@chakra-ui/react';
import { IconType } from 'react-icons';
import { FieldError, UseFormRegister } from 'react-hook-form';
import InputMask from 'react-input-mask';

interface InputProps extends ChakraInputProps {
  name: string;
  label?: string;
  icon?: IconType;
  error?: FieldError;
  register?: UseFormRegister<any>;
  autocomplete?: string;
  mask?: string;
  isInputMask?: boolean;
  isRequired?: boolean;
}

export const Input: React.VFC<InputProps> = ({
  name,
  label,
  icon,
  register = () => ({}),
  error = null,
  mask = null,
  isInputMask = false,
  isRequired = false,
  ...props
}) => {
  return !isInputMask ? (
    <FormControl isInvalid={!!error}>
      {!!label && (
        <FormLabel fontSize="14px" htmlFor={name}>
          {label} {isRequired && <span style={{ color: 'red' }}>*</span>}
        </FormLabel>
      )}
      <InputGroup>
        {icon && (
          <InputLeftElement pointerEvents="none">
            <Icon as={icon} color="gray.500" />
          </InputLeftElement>
        )}
        <ChakraInput
          bg="gray.100"
          borderColor="gray.300"
          _hover={{
            borderColor: 'gray.500',
          }}
          _placeholder={{
            color: 'gray.500',
          }}
          mask={mask}
          {...props}
          {...register(name)}
        />
      </InputGroup>
      {!!error && <FormErrorMessage>{error.message}</FormErrorMessage>}
    </FormControl>
  ) : (
    <FormControl isInvalid={!!error}>
      {!!label && (
        <FormLabel fontSize="14px" htmlFor={name}>
          {label} {isRequired && <span style={{ color: 'red' }}>*</span>}
        </FormLabel>
      )}
      <InputGroup>
        {icon && (
          <InputLeftElement pointerEvents="none">
            <Icon as={icon} color="gray.500" />
          </InputLeftElement>
        )}
        <ChakraInput
          bg="gray.100"
          borderColor="gray.300"
          _hover={{
            borderColor: 'gray.500',
          }}
          _placeholder={{
            color: 'gray.500',
          }}
          as={InputMask}
          mask={mask}
          maskChar=""
          {...props}
          {...register(name)}
        />
      </InputGroup>
      {!!error && <FormErrorMessage>{error.message}</FormErrorMessage>}
    </FormControl>
  );
};
